// extracted by mini-css-extract-plugin
module.exports = {"queue-items":"Queue_queue-items__3kxnU","actions":"Queue_actions__x4Stj","button--alt":"Queue_button--alt__23JBP","button":"Queue_button__30RnZ"};